import {
  ComponentFactoryResolver,
  ComponentRef,
  Injectable,
  ViewContainerRef,
  NgZone,
} from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { UnitService } from 'src/app/units/services/unit.service';
import { Unit } from 'src/app/units/models/unit';
import { VehicleHistoryDrawerService } from './vehicle-history-drawer.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import {
  ParamsGetFramesFromHistory,
  ResponseGetFramesFromHistory,
  RequestGetEventsFromHistory,
  RequestGetFramesFromHistory,
  RequestGetTimelineFromHistory,
  ResponseGetEventsFromHistory,
  ResponseGetTimelineFromHistory,
  StoreHistory,
  FrameHistory,
  FrameResult,
  TimelineResult,
  Stop,
  DataGetTimelineFromHistory,
  DetailsHistory,
  StartOrEnd,
  FrameHistoryAdapted,
  EventsResult,
  EventData,
  Movement,
  VariantFrameMarkers,
  ResponseServiceGeofence,
  ResponseCoordinates,
  DataGeofenceHistory,
  ResponseGeofenceHistory,
  ResponseCircularGeofenceHistory,
  ResponseServiceCircularGeofence,
  DataCircularGeofenceHistory,
  ResponseGeopointHistory,
  ResponseServiceGeopoint,
  DataGeopointHistory,
} from '../models/manager-content-vehicle-history-drawer.model';
import { MomentService } from 'src/app/vehicles/services/moment.service';
import { adaptParamsGetFramesFromHistory } from '../components/content-vehicle-history-drawer/adapters/adapt-request-get-frames.adapter';
import { ManagerLoadingHistoryService } from './manager-loading-history.service';
import { KEY_LOADING } from '../static/key-to-loading.static';
import { LeafletMapService } from 'src/app/map/services/leaflet-map.service';
import { printfError } from '../helpers/printf-error.helper';
import { ManagerErrorHistoryService } from './manager-error-history.service';
import { adaptParamsGetTimelineFromHistory } from '../components/content-vehicle-history-drawer/adapters/adapt-request-get-timeline.adapter';
import { simulateMovementsFromFrames } from '../helpers/simulate-movements.helper';
import {
  ResponseCreateMarker,
  ResponseCreatePolyline,
  ResponseCreatePolylineDecorator,
} from 'src/app/map/models/manager-leaflet.model';
import {
  createStartFrameIcon,
  createEndFrameIcon,
  createStopFrameIcon,
  createEventIcon,
  createSpeedFrameIcon,
  createTimeFrameIcon,
  createSpeedTimeFrameIcon,
} from 'src/app/historial/helpers/create-history-icons.helper';
import { HistorialService } from './historial.service';
import {
  adaptFrameHistoryToPopupEnd,
  createPopupEndFrame,
} from '../helpers/create-popup-end-frame.helper';
import {
  adaptFrameHistoryToPopupStart,
  createPopupStartFrame,
} from '../helpers/create-popup-start-frame.helper';
import {
  adaptFrameHistoryToPopupFrame,
  createPopupFrame,
} from '../helpers/create-popup-frame.helper';
import {
  adaptStopToPopupStop,
  createPopupStop,
} from '../helpers/create-popup-stop.helper';
import {
  createPopupMovement,
  adaptMovementToPopupMovement,
} from '../helpers/create-popup-movement.helper';
import { StateHistoryCardsService } from './state-history-cards.service';
import {
  idEndFrame,
  idStartFrame,
} from '../components/content-vehicle-history-drawer/static/ids-cards.static';
import { EventService } from 'src/app/events/services/event.service';
import {
  adaptEventToPopupEvent,
  createPopupEvent,
} from '../helpers/create-popup-event.helper';
import { MapAsideService } from 'src/app/panel/components/map-aside/service/map-aside.service';
import { addMultimediaComponentAsideMap } from '../helpers/create-multimedia-component.helper';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';
import { MultimediaService } from 'src/app/multiview/services/multimedia.service';
import { parseEventParams } from '../helpers/parse-event-params.helper';
import { isDateOlderThanTwoMinutes } from '../helpers/is-date-older-than.helper';
import * as L from 'leaflet';
import { createSpeedSegments } from '../helpers/create-speed-segments.helper';
import { createSpeedLegend } from '../helpers/create-speed-legend.helper';
import {
  createDirectionArrows,
  createSpeedBasedDirectionArrows,
  DirectionArrowOptions,
} from '../helpers/create-direction-arrows.helper';
import { GeofencesService } from 'src/app/geofences/services/geofences.service';
import { DataGeofence } from 'src/app/geofences/models/interfaces';
import {
  createGeofenceNameIcon,
  createGeopointNameIcon,
} from '../helpers/create-geofences-icons.helper';
import { hexToRGBA } from '../helpers/hex-to-rgba.helper';
import { CircularGeofencesService } from 'src/app/geofences/services/circular-geofences.service';
import { GeopointsService } from 'src/app/geopoints/services/geopoints.service';
import { COLOR_HISTORY } from '../static/color-elements.static';
import { DriversService } from 'src/app/drivers/services/drivers.service';

@Injectable({
  providedIn: 'root',
})
export class ManagerContentVehicleHistoryDrawerService {
  private currentImeiSubject = new BehaviorSubject<string>('');
  private storeHistorySubject = new BehaviorSubject<Map<string, StoreHistory>>(
    new Map()
  );
  private unitsSubject = new BehaviorSubject<Map<string, Unit>>(new Map());
  loadingCreateHistorySubject =
    this.managerLoadingHistoryService.getItemLoadingHistoryDinamic(
      KEY_LOADING.CREATE_HISTORY
    );
  errorCreateHistorySubject =
    this.managerErrorHistoryService.getItemErrorHistoryDinamic(
      KEY_LOADING.CREATE_HISTORY
    );

  private containerRef?: ComponentRef<any>;

  constructor(
    private unitService: UnitService,
    private http: HttpClient,
    private vehicleHistoryDrawerService: VehicleHistoryDrawerService,
    private momentService: MomentService,
    private managerLoadingHistoryService: ManagerLoadingHistoryService,
    private managerErrorHistoryService: ManagerErrorHistoryService,
    private leafletMapService: LeafletMapService,
    private historialService: HistorialService,
    private stateHistoryCardsService: StateHistoryCardsService,
    private eventService: EventService,
    private mapAsideService: MapAsideService,
    private resolver: ComponentFactoryResolver,
    private vehicleService: VehicleService,
    private ngZone: NgZone,
    private geofenceService: GeofencesService,
    private circularGeofenceService: CircularGeofencesService,
    private geopointService: GeopointsService,
    private driverService: DriversService
  ) {
    const destroy$ = new Subject<void>();
    unitService.getUnits
      .pipe(
        takeUntil(destroy$),
        tap((units) => {
          if (!units) return;
          const initialState = new Map<string, Unit>();
          units.forEach((unit) => {
            initialState.set(unit.GNSSIMEI, unit);
          });
          this.unitsSubject.next(initialState);
          destroy$.next();
          destroy$.complete();
        })
      )
      .subscribe();
  }

  get getHistories() {
    return this.storeHistorySubject.pipe(
      map((store) => Array.from(store.values()))
    );
  }

  get getHistory(): Observable<StoreHistory | undefined> {
    return this.currentImeiSubject.pipe(
      switchMap((imei) =>
        this.storeHistorySubject.pipe(map((store) => store.get(imei)))
      )
    );
  }

  set setCurrentImei(imei: string) {
    this.currentImeiSubject.next(imei);
  }

  getDetailVehicle(imei: string) {
    const units = this.unitsSubject.getValue();
    return units.get(imei);
  }

  private addHistoryInStore(imei: string, history: StoreHistory) {
    const store = this.storeHistorySubject.getValue();
    store.set(imei, history);
    this.storeHistorySubject.next(store);
  }

  private deleteOneHistory(imei: string) {
    const store = this.storeHistorySubject.getValue();
    store.delete(imei);
    this.storeHistorySubject.next(store);
  }

  deleteAllHistories() {
    this.storeHistorySubject.next(new Map());
    this.vehicleHistoryDrawerService.setStateDestroyedHistoryDrawer = true;
  }

  deleteHistory(imei: string) {
    const store = Array.from(this.storeHistorySubject.getValue().keys());
    this.deleteOneHistory(imei);
    if (store.length === 1) {
      this.vehicleHistoryDrawerService.setStateDestroyedHistoryDrawer = true;
      return;
    }
  }

  // deleteHistories() {
  //   this.deleteAllHistories();
  //   this.vehicleHistoryDrawerService.setStateDestroyedHistoryDrawer = true;
  // }

  createHistory(
    params: ParamsGetFramesFromHistory,
    container: ViewContainerRef
  ) {
    const bodyFramesAndEvents: RequestGetFramesFromHistory =
      adaptParamsGetFramesFromHistory(params, this.momentService);
    const bodyTimeline: RequestGetTimelineFromHistory =
      adaptParamsGetTimelineFromHistory(params);

    this.startLoadingCreateHistory();

    const promises = [
      this.getFramesFromHistory(bodyFramesAndEvents),
      this.getEventsFromHistory(bodyFramesAndEvents),
      this.getTimelineFromHistory(bodyTimeline),
    ] as const;

    Promise.all(promises)
      .then(
        ([framesResult, eventsResult, timelineResult]: [
          ResponseGetFramesFromHistory,
          ResponseGetEventsFromHistory,
          ResponseGetTimelineFromHistory
        ]) => {
          console.log('(HISTORY) framesResult', framesResult);
          console.log('(HISTORY) eventsResult', eventsResult);
          console.log('(HISTORY) timelineResult', timelineResult);
          if (timelineResult.data) {
            timelineResult.data.start_date = bodyTimeline.startDate;
            timelineResult.data.end_date = bodyTimeline.endDate;
          }
          // Simulamos movimientos basándose en los frames reales
          // if (timelineResult.data) {
          //   timelineResult.data.movements = simulateMovementsFromFrames(
          //     framesResult,
          //     100
          //   );
          // }

          // MANEJAMOS LOGICA Y ERROES DEL SERVICIO GETFRAMES
          const resultFrames = this.managerFramesResult(framesResult);
          if (resultFrames.error !== null) {
            this.managerErrorCreateHistory(resultFrames.error);
            return;
          }

          // MANEJAMOS LOGICA Y ERROES DEL SERVICIO GETEVENTS
          const resultEvents = this.managerEventsResult(
            eventsResult.data!,
            params.unit,
            container
          );
          if (resultEvents.error !== null) {
            this.managerErrorCreateHistory(resultEvents.error);
            return;
          }

          // MANEJAMOS LOGICA Y ERROES DEL SERVICIO GETTIMELINE
          const resultTimeline = this.managerTimelineResult(timelineResult);
          if (resultTimeline.error !== null) {
            this.managerErrorCreateHistory(resultTimeline.error);
            return;
          }

          // CREAMOS EL HISTORIAL COMPLETO
          this.addHistoryInStore(params.unit.GNSSIMEI, {
            unit: params.unit,
            detailsHistory: this.adaptToDetailHistory(
              timelineResult.data!,
              resultFrames.data!.startFrame,
              resultFrames.data!.endFrame,
              resultFrames.data!.frames,
              resultEvents.data!.events
            ),
            variantsFrameMarkers: resultFrames.data!.variantFrameMarkers,
            speedSegments: resultFrames.data!.speedSegments,
            speedLegend: resultFrames.data!.speedLegend,
            polyline: resultFrames.data!.polyline,
            polylineDecorator: resultFrames.data!.polylineDecorator,
            startMarker: resultFrames.data!.firstMarker,
            endMarker: resultFrames.data!.lastMarker,
            circleMarkers: resultFrames.data!.circleMarkers,
            stopMarkers: resultTimeline.data!.stopMarkers,
            eventsMarkers: resultEvents.data!.eventsMarkers,
            movementsPolylines: resultTimeline.data!.movementsPolylines,
            directionArrows: resultFrames.data!.directionArrows,
            speedDirectionArrows: resultFrames.data!.speedDirectionArrows,
          });
          this.setCurrentImei = params.unit.GNSSIMEI;

          // DESACTIVAMOS EL LOADING
          this.stopLoadingCreateHistory();
        }
      )
      .catch((err) => {
        this.managerErrorCreateHistory(
          'Ocurrio un error de conexión con el servidor'
        );
        console.error(
          '(HISTORY) Error en las requests: historial_varios, dataEventUserHistorial o timeline',
          err
        );
      });
  }

  private managerFramesResult(
    frames: ResponseGetFramesFromHistory
  ): FrameResult {
    if (frames.length === 0) {
      const errorMessage =
        'No se detecto ningún movimiento en el periodo seleccionado';
      return { data: null, error: errorMessage };
    }
    const currentFrames = frames[0] as FrameHistory[];

    const { polyline, error: errorPolyline } =
      this.managerCreatePolyline(currentFrames);
    if (errorPolyline !== null) {
      return { data: null, error: errorPolyline };
    }

    const { polylineDecorator, error: errorPolylineDecorator } =
      this.managerCreatePolylineDecorator(polyline);
    if (errorPolylineDecorator !== null) {
      return { data: null, error: errorPolylineDecorator };
    }
    // TypeScript assertion: después de verificar que error es null, polylineDecorator no puede ser null
    const validPolylineDecorator = polylineDecorator as L.PolylineDecorator;

    const { marker: firstMarker, error: errorFirstMarker } =
      this.managerCreateFirstMarker(currentFrames[0]);
    if (errorFirstMarker !== null) {
      return { data: null, error: errorFirstMarker };
    }

    const { marker: lastMarker, error: errorLastMarker } =
      this.managerCreateLastMarker(currentFrames[currentFrames.length - 1]);
    if (errorLastMarker !== null) {
      return { data: null, error: errorLastMarker };
    }

    const { circleMarkers, error: errorCircleMarkers } =
      this.managerCreateCircleMarkers(currentFrames);
    if (errorCircleMarkers !== null) {
      return { data: null, error: errorCircleMarkers };
    }

    // Crear variantes de markers para las tramas, ya no es necesario el validador de error
    const variantFrameMarkers =
      this.managerCreateVariantFrameMarkers(currentFrames);

    // Crear segmentos de ruta coloreados por velocidad
    const { speedSegments, speedLegend } =
      this.managerCreateSpeedSegments(currentFrames);

    // Crear flechas direccionales
    const directionArrows = this.managerCreateDirectionArrows(currentFrames);
    const speedDirectionArrows =
      this.managerCreateSpeedDirectionArrows(currentFrames);

    const startFrame = this.adaptFrameToStartOrEnd(currentFrames[0]);
    const endFrame = this.adaptFrameToStartOrEnd(
      currentFrames[currentFrames.length - 1]
    );
    const adaptedFrames = currentFrames.map((frame) =>
      this.adaptFrameToFrameHistory(frame)
    );

    return {
      data: {
        polyline,
        polylineDecorator: validPolylineDecorator,
        firstMarker,
        lastMarker,
        circleMarkers,
        variantFrameMarkers,
        speedSegments,
        speedLegend,
        directionArrows,
        speedDirectionArrows,
        startFrame,
        endFrame,
        frames: adaptedFrames,
      },
      error: null,
    };
  }

  private managerCreatePolyline(
    frames: FrameHistory[]
  ): ResponseCreatePolyline {
    const coordinates = this.adaptFramesToPolyline(frames);
    const { polyline, error } = this.leafletMapService.createPolylineLeaflet(
      coordinates,
      {
        color: COLOR_HISTORY.ROUTE_COLOR,
        weight: 4,
        opacity: 1,
      }
    );
    return { polyline, error };
  }

  private adaptFramesToPolyline(
    frames: FrameHistory[]
  ): { latitude: number; longitude: number }[] {
    return frames.map((frame) => this.adapterFrameToCoordinates(frame));
  }

  private managerCreatePolylineDecorator(polyline: L.Polyline) {
    const { polylineDecorator, error } =
      this.leafletMapService.createPolylineDecoratorLeaflet(polyline);
    return { polylineDecorator, error };
  }

  private managerCreateFirstMarker(
    firstFrame: FrameHistory
  ): ResponseCreateMarker {
    const icon = createStartFrameIcon();
    const response = this.leafletMapService.createMarkerWithIconLeaflet(
      this.adapterFrameToCoordinates(firstFrame),
      icon
    );
    if (response.error !== null) {
      return response;
    }

    // Establecer zIndexOffset para controlar la jerarquía
    // Los marcadores de inicio van en el nivel más alto
    response.marker.setZIndexOffset(500);

    const popup = createPopupStartFrame(
      adaptFrameHistoryToPopupStart(firstFrame)
    );
    const errorMessage = 'No se encontró dirección';
    response.marker.bindPopup(popup.html);
    response.marker.on('click', () => {
      response.marker.openPopup();
    });

    response.marker.on('popupopen', async () => {
      this.stateHistoryCardsService.selectCard(
        this.currentImeiSubject.getValue(),
        idStartFrame,
        'stops',
        'start'
      );

      await new Promise((resolve) => setTimeout(resolve, 0));

      this.setCopyListener(popup.ids.pos, popup.values.pos);
      this.setCopyListener(popup.ids.alt, popup.values.alt);
      this.setCopyListener(popup.ids.dir, popup.values.dir);
      this.setCopyListener(popup.ids.speed, popup.values.speed);
      this.setCopyListener(popup.ids.date, popup.values.date);

      if (!firstFrame.reference) {
        const refEl = document.getElementById(`${popup.ids.reference}-content`);
        if (refEl) refEl.innerHTML = 'Buscando dirección...';

        try {
          const result = await this.historialService.getReference(
            firstFrame.lat,
            firstFrame.lng
          );
          firstFrame.reference = result.referencia;
          if (refEl) refEl.innerHTML = firstFrame.reference ?? errorMessage;
          if (refEl?.innerText !== errorMessage) {
            this.setCopyListener(
              popup.ids.reference,
              firstFrame.reference ?? ''
            );
          }
        } catch (e) {
          if (refEl) refEl.innerHTML = errorMessage;
        }
      } else {
        const refEl = document.getElementById(`${popup.ids.reference}-content`);
        if (refEl) refEl.innerHTML = firstFrame.reference ?? errorMessage;
        if (refEl?.innerText !== errorMessage) {
          this.setCopyListener(popup.ids.reference, firstFrame.reference ?? '');
        }
      }
    });

    response.marker.on('popupclose', () => {
      this.stateHistoryCardsService.deselectCard(
        this.currentImeiSubject.getValue(),
        idStartFrame,
        'stops',
        'start'
      );
    });

    return { marker: response.marker, error: null };
  }

  private managerCreateLastMarker(
    lastFrame: FrameHistory
  ): ResponseCreateMarker {
    const icon = createEndFrameIcon();
    const response = this.leafletMapService.createMarkerWithIconLeaflet(
      this.adapterFrameToCoordinates(lastFrame),
      icon
    );
    if (response.error !== null) {
      return response;
    }

    // Establecer zIndexOffset para controlar la jerarquía
    // Los marcadores de fin van en el nivel más alto
    response.marker.setZIndexOffset(500);

    const popup = createPopupEndFrame(adaptFrameHistoryToPopupEnd(lastFrame));
    const errorMessage = 'No se encontró dirección';
    response.marker.bindPopup(popup.html);
    response.marker.on('click', () => {
      response.marker.openPopup();
    });
    response.marker.on('popupopen', async () => {
      this.stateHistoryCardsService.selectCard(
        this.currentImeiSubject.getValue(),
        idEndFrame,
        'stops',
        'end'
      );

      await new Promise((resolve) => setTimeout(resolve, 0));

      this.setCopyListener(popup.ids.pos, popup.values.pos);
      this.setCopyListener(popup.ids.alt, popup.values.alt);
      this.setCopyListener(popup.ids.dir, popup.values.dir);
      this.setCopyListener(popup.ids.speed, popup.values.speed);
      this.setCopyListener(popup.ids.date, popup.values.date);

      if (!lastFrame.reference) {
        const refEl = document.getElementById(`${popup.ids.reference}-content`);
        if (refEl) refEl.innerHTML = 'Buscando dirección...';

        try {
          const result = await this.historialService.getReference(
            lastFrame.lat,
            lastFrame.lng
          );
          lastFrame.reference = result.referencia;
          if (refEl) refEl.innerHTML = lastFrame.reference ?? errorMessage;
          if (refEl?.innerText !== errorMessage) {
            this.setCopyListener(
              popup.ids.reference,
              lastFrame.reference ?? ''
            );
          }
        } catch (e) {
          if (refEl) refEl.innerHTML = errorMessage;
        }
      } else {
        const refEl = document.getElementById(`${popup.ids.reference}-content`);
        if (refEl) refEl.innerHTML = lastFrame.reference ?? errorMessage;
        if (refEl?.innerText !== errorMessage) {
          this.setCopyListener(popup.ids.reference, lastFrame.reference ?? '');
        }
      }
    });
    response.marker.on('popupclose', () => {
      this.stateHistoryCardsService.deselectCard(
        this.currentImeiSubject.getValue(),
        idEndFrame,
        'stops',
        'end'
      );
    });
    return { marker: response.marker, error: null };
  }

  private managerCreateCircleMarkers(frames: FrameHistory[]) {
    let errorMessage = null;
    const circleMarkers: L.CircleMarker[] = [];
    for (const [index, frame] of frames.entries()) {
      const colorFrame = isDateOlderThanTwoMinutes(
        frame.dt_tracker,
        frame.dt_server
      )
        ? COLOR_HISTORY.FRAME_VARIANT_V1_COLOR
        : COLOR_HISTORY.FRAME_DEFAULT_COLOR;
      const variantFrame = isDateOlderThanTwoMinutes(
        frame.dt_tracker,
        frame.dt_server
      )
        ? 'v1'
        : 'default';
      const { circleMarker, error } =
        this.leafletMapService.createCircleMarkerLeaflet(
          this.adapterFrameToCoordinates(frame),
          {
            fillColor: colorFrame,
          }
        );
      if (error !== null) {
        errorMessage = error;
        break;
      }

      // LOGICA PARA AÑADIR EL POPUP A CADA CIRCLEMARKER
      const popup = createPopupFrame(
        adaptFrameHistoryToPopupFrame(frame),
        index + 1,
        colorFrame
      );
      circleMarker.bindPopup(popup.html);
      circleMarker.on('click', () => {
        circleMarker.openPopup();
      });
      circleMarker.on('popupopen', async () => {
        this.stateHistoryCardsService.selectCard(
          this.currentImeiSubject.getValue(),
          index + 1,
          'frames',
          variantFrame
        );

        await new Promise((resolve) => setTimeout(resolve, 0));

        this.setCopyListener(popup.ids.pos, popup.values.pos);
        this.setCopyListener(popup.ids.alt, popup.values.alt);
        this.setCopyListener(popup.ids.dir, popup.values.dir);
        this.setCopyListener(popup.ids.speed, popup.values.speed);
        this.setCopyListener(popup.ids.date, popup.values.date);
      });
      circleMarker.on('popupclose', () => {
        this.stateHistoryCardsService.deselectCard(
          this.currentImeiSubject.getValue(),
          index + 1,
          'frames',
          variantFrame
        );
      });

      circleMarkers.push(circleMarker);
    }
    if (errorMessage !== null) {
      return { circleMarkers: [], error: errorMessage };
    }
    return { circleMarkers, error: null };
  }

  private managerCreateSpeedSegments(frames: FrameHistory[]): {
    speedSegments: L.Polyline[];
    speedLegend: L.Control;
  } {
    // Crear segmentos de ruta coloreados por velocidad
    const speedSegments = createSpeedSegments(frames, {
      interactive: false,
    });

    // Crear leyenda de velocidad
    const speedLegend = createSpeedLegend({
      position: 'bottomright',
      className: 'speed-legend-control',
    });

    return {
      speedSegments,
      speedLegend,
    };
  }

  private managerCreateDirectionArrows(frames: FrameHistory[]): L.Marker[] {
    const arrowOptions: DirectionArrowOptions = {
      color: '#000',
      weight: 2,
      opacity: 1,
      arrowSize: 18,
      arrowSpacing: 150, // 150 metros entre flechas
    };
    return createDirectionArrows(frames, arrowOptions);
  }

  private managerCreateSpeedDirectionArrows(
    frames: FrameHistory[]
  ): L.Marker[] {
    const arrowOptions: DirectionArrowOptions = {
      weight: 2,
      opacity: 1,
      arrowSize: 18,
      arrowSpacing: 200, // 200 metros entre flechas para velocidad
    };
    return createSpeedBasedDirectionArrows(frames, arrowOptions);
  }

  private managerCreateVariantFrameMarkers(
    frames: FrameHistory[]
  ): VariantFrameMarkers {
    // const basic: L.CircleMarker[] = [];
    const speed: L.Marker[] = [];
    const time: L.Marker[] = [];
    const speedTime: L.Marker[] = [];

    for (const [index, frame] of frames.entries()) {
      const coordinates = this.adapterFrameToCoordinates(frame);
      const frameDate = new Date(frame.dt_tracker);
      const colorFrame = isDateOlderThanTwoMinutes(
        frame.dt_tracker,
        frame.dt_server
      )
        ? COLOR_HISTORY.FRAME_VARIANT_V1_COLOR
        : COLOR_HISTORY.FRAME_DEFAULT_COLOR;
      const variantFrame = isDateOlderThanTwoMinutes(
        frame.dt_tracker,
        frame.dt_server
      )
        ? 'v1'
        : 'default';

      // // Crear marker básico (CircleMarker)
      // const { circleMarker, error: basicError } =
      //   this.leafletMapService.createCircleMarkerLeaflet(coordinates, {
      //     fillColor: isDateOlderThanTwoMinutes(
      //       frame.dt_tracker,
      //       frame.dt_server
      //     )
      //       ? '#FFC107'
      //       : '#1976D2',
      //   });

      // if (basicError) continue;
      // basic.push(circleMarker);

      // Crear marker de velocidad
      const speedIcon = createSpeedFrameIcon({
        size: 48,
        speed: frame.speed,
        time: frameDate,
        color: colorFrame,
        textColor: '#000000',
      });

      const speedMarker = L.marker(
        [coordinates.latitude, coordinates.longitude],
        { icon: speedIcon }
      );
      // Establecer zIndexOffset para controlar la jerarquía
      speedMarker.setZIndexOffset(300);
      speed.push(speedMarker);

      // Crear marker de tiempo
      const timeIcon = createTimeFrameIcon({
        size: 56,
        speed: frame.speed,
        time: frameDate,
        color: colorFrame,
        textColor: '#000000',
      });

      const timeMarker = L.marker(
        [coordinates.latitude, coordinates.longitude],
        { icon: timeIcon }
      );
      // Establecer zIndexOffset para controlar la jerarquía
      timeMarker.setZIndexOffset(300);
      time.push(timeMarker);

      // Crear marker de velocidad y tiempo
      const speedTimeIcon = createSpeedTimeFrameIcon({
        size: 56,
        speed: frame.speed,
        time: frameDate,
        color: colorFrame,
        textColor: '#000000',
      });

      const speedTimeMarker = L.marker(
        [coordinates.latitude, coordinates.longitude],
        { icon: speedTimeIcon }
      );
      // Establecer zIndexOffset para controlar la jerarquía
      speedTimeMarker.setZIndexOffset(300);
      speedTime.push(speedTimeMarker);

      // Configurar popup y eventos para todos los markers (reutilizar la lógica existente)
      const popup = createPopupFrame(
        adaptFrameHistoryToPopupFrame(frame),
        index + 1,
        colorFrame
      );

      // Configurar popup para marker de velocidad
      speedMarker.bindPopup(popup.html);
      speedMarker.on('click', () => speedMarker.openPopup());
      speedMarker.on('popupopen', async () => {
        this.stateHistoryCardsService.selectCard(
          this.currentImeiSubject.getValue(),
          index + 1,
          'frames',
          variantFrame
        );
        await new Promise((resolve) => setTimeout(resolve, 0));
        this.setCopyListener(popup.ids.pos, popup.values.pos);
        this.setCopyListener(popup.ids.alt, popup.values.alt);
        this.setCopyListener(popup.ids.dir, popup.values.dir);
        this.setCopyListener(popup.ids.speed, popup.values.speed);
        this.setCopyListener(popup.ids.date, popup.values.date);
      });
      speedMarker.on('popupclose', () => {
        this.stateHistoryCardsService.deselectCard(
          this.currentImeiSubject.getValue(),
          index + 1,
          'frames',
          variantFrame
        );
      });

      // Configurar popup para marker de tiempo
      timeMarker.bindPopup(popup.html);
      timeMarker.on('click', () => timeMarker.openPopup());
      timeMarker.on('popupopen', async () => {
        this.stateHistoryCardsService.selectCard(
          this.currentImeiSubject.getValue(),
          index + 1,
          'frames',
          variantFrame
        );
        await new Promise((resolve) => setTimeout(resolve, 0));
        this.setCopyListener(popup.ids.pos, popup.values.pos);
        this.setCopyListener(popup.ids.alt, popup.values.alt);
        this.setCopyListener(popup.ids.dir, popup.values.dir);
        this.setCopyListener(popup.ids.speed, popup.values.speed);
        this.setCopyListener(popup.ids.date, popup.values.date);
      });
      timeMarker.on('popupclose', () => {
        this.stateHistoryCardsService.deselectCard(
          this.currentImeiSubject.getValue(),
          index + 1,
          'frames',
          variantFrame
        );
      });

      // Configurar popup para marker de velocidad y tiempo
      speedTimeMarker.bindPopup(popup.html);
      speedTimeMarker.on('click', () => speedTimeMarker.openPopup());
      speedTimeMarker.on('popupopen', async () => {
        this.stateHistoryCardsService.selectCard(
          this.currentImeiSubject.getValue(),
          index + 1,
          'frames',
          variantFrame
        );
        await new Promise((resolve) => setTimeout(resolve, 0));
        this.setCopyListener(popup.ids.pos, popup.values.pos);
        this.setCopyListener(popup.ids.alt, popup.values.alt);
        this.setCopyListener(popup.ids.dir, popup.values.dir);
        this.setCopyListener(popup.ids.speed, popup.values.speed);
        this.setCopyListener(popup.ids.date, popup.values.date);
      });
      speedTimeMarker.on('popupclose', () => {
        this.stateHistoryCardsService.deselectCard(
          this.currentImeiSubject.getValue(),
          index + 1,
          'frames',
          variantFrame
        );
      });
    }

    return {
      speed,
      time,
      speedTime,
    };
  }

  private adaptFrameToStartOrEnd(frame: FrameHistory): StartOrEnd {
    return {
      date: frame.dt_tracker,
      latitude: parseFloat(frame.lat),
      longitude: parseFloat(frame.lng),
      reference: frame.reference ?? undefined,
    };
  }

  private adaptFrameToFrameHistory(frame: FrameHistory): FrameHistoryAdapted {
    return {
      date: frame.dt_tracker,
      latitude: parseFloat(frame.lat),
      longitude: parseFloat(frame.lng),
      speed: frame.speed,
      direction: frame.angle,
      altitude: frame.altitude,
      variant: isDateOlderThanTwoMinutes(frame.dt_tracker, frame.dt_server)
        ? 'v1'
        : 'default',
      IOs: this.unitService.parseParams(frame.params),
    };
  }

  private managerTimelineResult(
    timeline: ResponseGetTimelineFromHistory
  ): TimelineResult {
    if (timeline.status === false) return { data: null, error: 'Error' };
    const { stopMarkers, error: errorStopMarkers } =
      this.managerCreateStopMarkers(timeline.data!.stops);
    if (errorStopMarkers !== null) {
      return { data: null, error: errorStopMarkers };
    }

    const { movementsPolylines, error: errorMovementsPolylines } =
      this.managerCreateMovementsPolylines(timeline.data!.movements);
    if (errorMovementsPolylines !== null) {
      return { data: null, error: errorMovementsPolylines };
    }

    return { data: { stopMarkers, movementsPolylines }, error: null };
  }

  private managerCreateStopMarkers(stops: Stop[]) {
    let errorMessage = null;
    const stopMarkers: L.Marker[] = [];
    const icon = createStopFrameIcon();
    for (const [index, stop] of stops.entries()) {
      const { marker, error } =
        this.leafletMapService.createMarkerWithIconLeaflet(
          { latitude: stop.latitude, longitude: stop.longitude },
          icon
        );
      if (error !== null) {
        errorMessage = error;
        break;
      }

      // Establecer zIndexOffset para controlar la jerarquía
      // Los marcadores de paradas van en un nivel alto
      marker.setZIndexOffset(400);

      const errorMessageReference = 'No se encontró dirección';
      const popup = createPopupStop(adaptStopToPopupStop(stop), index + 1);
      marker.bindPopup(popup.html);

      marker.on('click', () => {
        marker.openPopup();
      });
      marker.on('popupopen', async () => {
        this.stateHistoryCardsService.selectCard(
          this.currentImeiSubject.getValue(),
          index + 1,
          'stops',
          'stop'
        );

        await new Promise((resolve) => setTimeout(resolve, 0));
        this.setCopyListener(popup.ids.pos, popup.values.pos);
        this.setCopyListener(popup.ids.duration, popup.values.duration);
        this.setCopyListener(popup.ids.startDate, popup.values.startDate);
        this.setCopyListener(popup.ids.endDate, popup.values.endDate);

        if (!stop.reference) {
          const refEl = document.getElementById(
            `${popup.ids.reference}-content`
          );
          if (refEl) refEl.innerHTML = 'Buscando dirección...';
          try {
            const result = await this.historialService.getReference(
              stop.latitude.toString(),
              stop.longitude.toString()
            );
            stop.reference = result.referencia;
            if (refEl)
              refEl.innerHTML = stop.reference ?? errorMessageReference;
            if (refEl?.innerText !== errorMessageReference) {
              this.setCopyListener(popup.ids.reference, stop.reference ?? '');
            }
          } catch (e) {
            if (refEl) refEl.innerHTML = errorMessageReference;
          }
        } else {
          const refEl = document.getElementById(
            `${popup.ids.reference}-content`
          );
          if (refEl) refEl.innerHTML = stop.reference ?? errorMessageReference;
          if (refEl?.innerText !== errorMessageReference) {
            this.setCopyListener(popup.ids.reference, stop.reference ?? '');
          }
        }
      });
      marker.on('popupclose', () => {
        this.stateHistoryCardsService.deselectCard(
          this.currentImeiSubject.getValue(),
          index + 1,
          'stops',
          'stop'
        );
      });

      stopMarkers.push(marker);
    }
    if (errorMessage !== null) {
      return { stopMarkers: [], error: errorMessage };
    }
    return { stopMarkers, error: null };
  }

  private managerCreateMovementsPolylines(movements: Movement[]) {
    let errorMessage = null;
    const movementsPolylines: L.Polyline[] = [];
    const errorMessageReference = 'No se encontró dirección';

    for (const [index, movement] of movements.entries()) {
      const { polyline, error } = this.leafletMapService.createPolylineLeaflet(
        movement.coords,
        {
          opacity: 0,
          color: COLOR_HISTORY.ROUTE_MOVEMENT_COLOR,
          weight: 6,
          interactive: true,
        }
      );
      if (error !== null) {
        errorMessage = error;
        break;
      }

      const popup = createPopupMovement(
        adaptMovementToPopupMovement(movement),
        index + 1
      );
      polyline.bindPopup(popup.html);

      polyline.on('click', () => {
        polyline.openPopup();
      });
      polyline.on('popupopen', async () => {
        // Cambiar el color de la polyline a amarillo cuando se abre el popup
        polyline.setStyle({
          opacity: 0.9,
        });

        this.stateHistoryCardsService.selectCard(
          this.currentImeiSubject.getValue(),
          index + 1,
          'stops',
          'movement'
        );

        await new Promise((resolve) => setTimeout(resolve, 0));

        // Configurar listeners de copia para todos los campos
        this.setCopyListener(popup.ids.startPos, popup.values.startPos);
        this.setCopyListener(popup.ids.endPos, popup.values.endPos);
        this.setCopyListener(popup.ids.avgSpeed, popup.values.avgSpeed);
        this.setCopyListener(popup.ids.distance, popup.values.distance);
        this.setCopyListener(popup.ids.startDate, popup.values.startDate);
        this.setCopyListener(popup.ids.endDate, popup.values.endDate);

        // Manejar referencia de inicio
        if (!movement.reference_start) {
          const startRefEl = document.getElementById(
            `${popup.ids.startReference}-content`
          );
          if (startRefEl) startRefEl.innerHTML = 'Buscando dirección...';
          try {
            const resultStart = await this.historialService.getReference(
              movement.coords[0].latitude.toString(),
              movement.coords[0].longitude.toString()
            );
            movement.reference_start = resultStart.referencia;
            if (startRefEl)
              startRefEl.innerHTML =
                movement.reference_start ?? errorMessageReference;
            if (startRefEl?.innerText !== errorMessageReference) {
              this.setCopyListener(
                popup.ids.startReference,
                movement.reference_start ?? ''
              );
            }
          } catch (e) {
            if (startRefEl) startRefEl.innerHTML = errorMessageReference;
          }
        } else {
          const startRefEl = document.getElementById(
            `${popup.ids.startReference}-content`
          );
          if (startRefEl)
            startRefEl.innerHTML =
              movement.reference_start ?? errorMessageReference;
          if (startRefEl?.innerText !== errorMessageReference) {
            this.setCopyListener(
              popup.ids.startReference,
              movement.reference_start ?? ''
            );
          }
        }

        await new Promise((resolve) => setTimeout(resolve, 0));

        // Manejar referencia de fin
        if (!movement.reference_end) {
          const endRefEl = document.getElementById(
            `${popup.ids.endReference}-content`
          );
          if (endRefEl) endRefEl.innerHTML = 'Buscando dirección...';
          try {
            const resultEnd = await this.historialService.getReference(
              movement.coords[movement.coords.length - 1].latitude.toString(),
              movement.coords[movement.coords.length - 1].longitude.toString()
            );
            movement.reference_end = resultEnd.referencia;
            if (endRefEl)
              endRefEl.innerHTML =
                movement.reference_end ?? errorMessageReference;
            if (endRefEl?.innerText !== errorMessageReference) {
              this.setCopyListener(
                popup.ids.endReference,
                movement.reference_end ?? ''
              );
            }
          } catch (e) {
            if (endRefEl) endRefEl.innerHTML = errorMessageReference;
          }
        } else {
          const endRefEl = document.getElementById(
            `${popup.ids.endReference}-content`
          );
          if (endRefEl)
            endRefEl.innerHTML =
              movement.reference_end ?? errorMessageReference;
          if (endRefEl?.innerText !== errorMessageReference) {
            this.setCopyListener(
              popup.ids.endReference,
              movement.reference_end ?? ''
            );
          }
        }
      });
      polyline.on('popupclose', () => {
        // Restaurar el estado original de la polyline cuando se cierra el popup
        polyline.setStyle({
          opacity: 0,
        });

        this.stateHistoryCardsService.deselectCard(
          this.currentImeiSubject.getValue(),
          index + 1,
          'stops',
          'movement'
        );
      });
      polyline.on('mouseover', () => {
        if (!polyline.isPopupOpen()) {
          polyline.setStyle({
            opacity: 0.9,
          });
        }
      });
      polyline.on('mouseout', () => {
        if (!polyline.isPopupOpen()) {
          polyline.setStyle({
            opacity: 0,
          });
        }
      });

      movementsPolylines.push(polyline);
    }
    if (errorMessage !== null) {
      return { movementsPolylines: [], error: errorMessage };
    }
    return { movementsPolylines, error: null };
  }

  private adaptToDetailHistory(
    timeline: DataGetTimelineFromHistory,
    startFrame: StartOrEnd,
    endFrame: StartOrEnd,
    frames: FrameHistoryAdapted[],
    events: EventData[]
  ): DetailsHistory {
    return {
      start_date: timeline.start_date,
      end_date: timeline.end_date,
      total_distance_km: timeline.total_distance_km,
      duration_ignition_on_s: timeline.duration_ignition_on_s,
      duration_ignition_off_s: timeline.duration_ignition_off_s,
      stops: timeline.stops,
      max_speed: timeline.max_speed,
      avg_speed: timeline.avg_speed,
      stopped_time: timeline.stopped_time,
      movement_time: timeline.movement_time,
      valid_stops: timeline.valid_stops,
      idle_time: timeline.idle_time,
      tramas_count: timeline.tramas_count,
      startFrame,
      endFrame,
      frames,
      events,
      movements: timeline.movements,
    };
  }

  private managerEventsResult(
    events: EventData[],
    unit: Unit,
    container: ViewContainerRef
  ): EventsResult {
    // Reverse the events array before creating markers
    const reversedEvents = [...events].reverse();

    const { eventsMarkers, error: errorEventsMarkers } =
      this.managerCreateEventsMarkers(reversedEvents, unit, container);
    if (errorEventsMarkers !== null) {
      return { data: null, error: errorEventsMarkers };
    }
    return { data: { events: reversedEvents, eventsMarkers }, error: null };
  }

  private managerCreateEventsMarkers(
    events: EventData[],
    unit: Unit,
    container: ViewContainerRef
  ) {
    let errorMessage = null;
    const eventsMarkers: L.Marker[] = [];
    const drivers = this.driverService.drivers;
    for (const [index, event] of events.entries()) {
      const icon = createEventIcon(event, this.eventService);

      const { marker, error } =
        this.leafletMapService.createMarkerWithIconLeaflet(
          this.adapterEventToCoordinates(event),
          icon
        );
      if (error !== null) {
        errorMessage = error;
        break;
      }

      // Establecer zIndexOffset para controlar la jerarquía
      // Los marcadores de eventos van en un nivel alto
      marker.setZIndexOffset(400);

      const customId = `${unit.GNSSIMEI}-event-${index + 1}`;

      const driverFound = drivers.find((d) =>
        d?.id != null && event?.driver_id != null
          ? d.id.toString() === event.driver_id.toString()
          : false
      );
      let nameDriver = 'No identificado';
      if (driverFound) {
        nameDriver = driverFound.nombre_conductor;
      }

      const popup = createPopupEvent(
        adaptEventToPopupEvent({
          customId,
          ...event,
          name_driver:
            nameDriver === 'No identificado'
              ? nameDriver
              : nameDriver.toUpperCase(),
        }),
        index + 1
      );
      marker.bindPopup(popup.html);
      marker.on('click', () => {
        marker.openPopup();
      });
      marker.on('popupopen', async () => {
        this.stateHistoryCardsService.selectCard(
          this.currentImeiSubject.getValue(),
          index + 1,
          'events',
          'event'
        );

        await new Promise((resolve) => setTimeout(resolve, 0));
        this.setCopyListener(popup.ids.pos, popup.values.pos);
        this.setCopyListener(popup.ids.alt, popup.values.alt);
        this.setCopyListener(popup.ids.dir, popup.values.dir);
        this.setCopyListener(popup.ids.speed, popup.values.speed);
        this.setCopyListener(popup.ids.date, popup.values.date);
        this.setCopyListener(popup.ids.reference, popup.values.reference);
        this.setCopyListener(popup.ids.driver, popup.values.driver);

        const customBtn = document.getElementById(popup.ids.viewFull);

        let evento ={
          ...event,
          parametros: parseEventParams(event.parametros),
          parametrosString: event.parametros,
        }

        if (customBtn) {
          customBtn.addEventListener('click', async (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (this.containerRef) {
              this.containerRef.destroy();
            }
            const { componentRef, error } = addMultimediaComponentAsideMap(
              evento,
              this.eventService,
              this.resolver,
              container,
              this.vehicleService
            );
            if (error !== null) {
              console.error('Error al agregar el componente multimedia', error);
              this.containerRef = undefined;
              this.mapAsideService.show('events', {
                ...evento,
                componentRef: null,
                flagEventPopup: true,
              });
              return;
            }
            this.containerRef = componentRef ?? undefined;
            this.mapAsideService.show('events', {
              ...evento,
              componentRef,
              flagEventPopup: true,
            });
            this.forceRender(1000);
          });
        }
      });
      marker.on('popupclose', () => {
        this.stateHistoryCardsService.deselectCard(
          this.currentImeiSubject.getValue(),
          index + 1,
          'events',
          'event'
        );
        this.mapAsideService.hide();
      });
      eventsMarkers.push(marker);
    }
    if (errorMessage !== null) {
      return { eventsMarkers: [], error: errorMessage };
    }
    return { eventsMarkers, error: null };
  }

  private adapterEventToCoordinates(event: EventData): {
    latitude: number;
    longitude: number;
  } {
    return {
      latitude: parseFloat(event.latitud),
      longitude: parseFloat(event.longitud),
    };
  }

  private adapterFrameToCoordinates(frame: FrameHistory): {
    latitude: number;
    longitude: number;
  } {
    return {
      latitude: parseFloat(frame.lat),
      longitude: parseFloat(frame.lng),
    };
  }

  private setCopyListener(id: string, value: string) {
    const elButton = document.getElementById(id);
    const elContent = document.getElementById(`${id}-content`);
    if (elButton && elContent) {
      elButton.onclick = () => {
        navigator.clipboard.writeText(value);
        const original = elContent.innerHTML;
        if (original === '¡Copiado!') return;
        elContent.innerHTML = '¡Copiado!';
        setTimeout(() => {
          elContent.innerHTML = original;
        }, 1500);
      };
    }
  }

  private managerErrorCreateHistory(error: any) {
    printfError(error);
    this.sendErrorCreateHistory(error);
    this.stopLoadingCreateHistory();
  }

  private getFramesFromHistory(
    body: RequestGetFramesFromHistory
  ): Promise<ResponseGetFramesFromHistory> {
    return this.http
      .post<ResponseGetFramesFromHistory>(
        `${environment.apiUrl}/api/historial_varios`,
        body
      )
      .toPromise();
  }
  private getTimelineFromHistory(
    body: RequestGetTimelineFromHistory
  ): Promise<ResponseGetTimelineFromHistory> {
    return this.http
      .post<ResponseGetTimelineFromHistory>(
        `${environment.apiUrl}/api/v1/vehicles/timeline`,
        body
      )
      .toPromise();
  }

  private getEventsFromHistory(
    body: RequestGetEventsFromHistory
  ): Promise<ResponseGetEventsFromHistory> {
    return this.http
      .post<ResponseGetEventsFromHistory>(
        `${environment.apiUrl}/api/dataEventUserHistorial`,
        body
      )
      .toPromise();
  }

  private forceRender(waitTime: number) {
    setTimeout(() => {
      this.ngZone.runOutsideAngular(() => {
        this.ngZone.run(() => {
          const keyboardEvent = new KeyboardEvent('keydown', {
            key: 'Tab',
            bubbles: true,
            cancelable: true,
            keyCode: 9,
          });
          document.dispatchEvent(keyboardEvent);
        });
      });
    }, waitTime);
  }

  getGeofences(): ResponseGeofenceHistory {
    const dataGeofence: ResponseServiceGeofence[] =
      this.geofenceService.getData();

    let messageError: string | null = null;
    const store: DataGeofenceHistory[] = [];

    for (const data of dataGeofence) {
      if (data.zone_visible !== 'true') {
        continue;
      }

      const coordsResponse: ResponseCoordinates = JSON.parse(
        data.geo_coordenadas
      );
      const coordenates = coordsResponse.coordinates[0] || [];
      if (coordenates.length === 0) {
        messageError = 'No se encontraron coordenadas para la geofence';
        break;
      }

      const adaptedCoords = this.adaptCoordenatesGeofence(coordenates);

      const polygonOptions: L.PolylineOptions = {
        color: data.zone_color || '#FF0000',
        fill: true,
        weight: 3,
        interactive: true,
      };

      const { polygon, error: errorPolygon } =
        this.leafletMapService.createPolygonLeaflet(
          adaptedCoords,
          polygonOptions
        );
      if (errorPolygon) {
        messageError = errorPolygon;
        break;
      }

      const coordenateCenterPolyline = polygon.getBounds().getCenter();

      const icon = createGeofenceNameIcon({
        name: data.zone_name || 'Geocerca',
        textColor: this.getTextColor(data.tag_name_color, data.zone_color),
        backgroundColor: this.getBgColor(data.zone_color),
        fontSize: this.getFontSize(data.tag_name_font_size) || 10,
      });

      const { marker, error: errorMarker } =
        this.leafletMapService.createMarkerWithIconLeaflet(
          this.adapterCoordenateGeofenceFromLatLng(coordenateCenterPolyline),
          icon,
          {
            interactive: false,
          }
        );
      if (errorMarker) {
        messageError = errorMarker;
        break;
      }

      marker.setZIndexOffset(200);

      // Si el marker no debe ser visible, configurar opacity 0 y eventos hover
      if (data.zone_name_visible !== 'true') {
        marker.setOpacity(0);

        polygon.on('mouseover', () => {
          marker.setOpacity(1);
        });

        polygon.on('mouseout', () => {
          marker.setOpacity(0);
        });
      }

      store.push({ polygon, marker });
    }

    if (messageError) {
      return { data: null, error: messageError };
    }

    return { data: store, error: null };
  }

  private adaptCoordenatesGeofence(
    data: number[][]
  ): { latitude: number; longitude: number }[] {
    return data.map((item) => ({
      latitude: item[1], // GeoJSON format: [longitude, latitude]
      longitude: item[0], // So we need to swap them
    }));
  }

  private adapterCoordenateGeofenceFromLatLng(data: L.LatLng): {
    latitude: number;
    longitude: number;
  } {
    return {
      latitude: data.lat,
      longitude: data.lng,
    };
  }

  private getTextColor(tag_name_color: string, zone_color: string) {
    return this.geofenceService.tooltipBackgroundTransparent
      ? tag_name_color === ''
        ? this.geofenceService.defaultTagNameColor
        : tag_name_color
      : hexToRGBA(zone_color);
  }

  private getBgColor(zone_color: string) {
    return this.geofenceService.tooltipBackgroundTransparent
      ? this.geofenceService.defaultTagNameBackground
      : hexToRGBA(zone_color);
  }

  private getFontSize(tag_name_font_size: number) {
    return tag_name_font_size == 0 ? 10 : tag_name_font_size;
  }

  getCircularGeofences(): ResponseCircularGeofenceHistory {
    const dataCircularGeofence: ResponseServiceCircularGeofence[] =
      this.circularGeofenceService.getData();

    let messageError: string | null = null;
    const store: DataCircularGeofenceHistory[] = [];

    for (const data of dataCircularGeofence) {
      if (data.zone_visible !== 'true') {
        continue;
      }

      // Parsear coordenadas circulares: "<(-11.674176881198218,-44.91210937500001),260420.36085841252>"
      const coordinates = this.parseCircularCoordinates(data.geo_coordenadas);
      if (!coordinates) {
        messageError = 'No se pudieron parsear las coordenadas circulares';
        break;
      }

      const circleOptions: L.PathOptions = {
        fillColor: data.zone_color || '#3388ff',
        fillOpacity: 0.2,
        color: data.zone_color || '#3388ff',
        weight: 3,
        opacity: 0.8,
        interactive: false,
      };

      const { circle, error: errorCircle } =
        this.leafletMapService.createCircleLeaflet(
          coordinates.center,
          coordinates.radius,
          circleOptions
        );

      if (errorCircle || circle === null) {
        messageError = errorCircle;
        break;
      }

      if (data.zone_name_visible !== 'true') {
        store.push({ circle, marker: null });
        continue;
      }

      const coordenateCenterCircle = circle.getLatLng();

      const icon = createGeofenceNameIcon({
        name: data.zone_name || 'Geocerca',
        textColor: this.getTextColorCircularGeofence(
          data.tag_name_color,
          data.zone_color
        ),
        backgroundColor: this.getBgColorCircularGeofence(data.zone_color),
        fontSize:
          this.getFontSizeCircularGeofence(Number(data.tag_name_font_size)) ||
          10,
      });

      const { marker, error: errorMarker } =
        this.leafletMapService.createMarkerWithIconLeaflet(
          this.adapterCoordenateGeofenceFromLatLng(coordenateCenterCircle),
          icon,
          {
            interactive: false,
          }
        );
      if (errorMarker) {
        messageError = errorMarker;
        break;
      }

      marker.setZIndexOffset(200);

      store.push({ circle, marker });
    }

    if (messageError) {
      return { data: null, error: messageError };
    }

    return { data: store, error: null };
  }

  private parseCircularCoordinates(geoCoordinates: string): {
    center: { latitude: number; longitude: number };
    radius: number;
  } | null {
    try {
      // Formato: "<(-11.674176881198218,-44.91210937500001),260420.36085841252>"
      const match = geoCoordinates.match(/<\(([^,]+),([^)]+)\),([^>]+)>/);
      if (!match) {
        return null;
      }

      const latitude = parseFloat(match[1]);
      const longitude = parseFloat(match[2]);
      const radius = parseFloat(match[3]);

      if (isNaN(latitude) || isNaN(longitude) || isNaN(radius)) {
        return null;
      }

      return {
        center: { latitude, longitude },
        radius,
      };
    } catch (error) {
      return null;
    }
  }

  private getTextColorCircularGeofence(
    tag_name_color: string,
    zone_color: string
  ) {
    return this.circularGeofenceService.tooltipBackgroundTransparent
      ? tag_name_color === ''
        ? this.circularGeofenceService.defaultTagNameColor
        : tag_name_color
      : hexToRGBA(zone_color);
  }

  private getBgColorCircularGeofence(zone_color: string) {
    return this.circularGeofenceService.tooltipBackgroundTransparent
      ? this.circularGeofenceService.defaultTagNameBackground
      : hexToRGBA(zone_color);
  }

  private getFontSizeCircularGeofence(tag_name_font_size: number) {
    return tag_name_font_size == 0 ? 10 : tag_name_font_size;
  }

  getGeopoints(): ResponseGeopointHistory {
    const dataGeopoint: ResponseServiceGeopoint[] =
      this.geopointService.getData();

    let messageError: string | null = null;
    const store: DataGeopointHistory[] = [];

    for (const data of dataGeopoint) {
      if (data.geopunto_visible !== 'true') {
        continue;
      }
      const [lat, lng] = data.geopunto_vertices.split(',').map(Number);
      const coordsResponse = {
        latitude: lat,
        longitude: lng,
      };

      const divIcon = L.divIcon({
        html: this.geopointService.geopointHTMLMarkerIcon(data.geopunto_color),
        className: '',
        iconSize: [24, 41.86],
        iconAnchor: [12, 41.86],
      });

      const { marker: markerGeopoint, error: errorMarkerGeopoint } =
        this.leafletMapService.createMarkerWithIconLeaflet(
          coordsResponse,
          divIcon,
          {},
          false
        );
      if (errorMarkerGeopoint) {
        messageError = errorMarkerGeopoint;
        break;
      }

      markerGeopoint.setZIndexOffset(200);

      markerGeopoint.bindPopup(
        '<span">Latitud: ' +
          coordsResponse.latitude +
          '<br>Longitud: ' +
          coordsResponse.longitude +
          '</span>',
        { offset: [0, -20] }
      );

      if (data.geopunto_nombre_visible !== 'true') {
        store.push({ markerGeopoint, markerName: null });
        continue;
      }

      const icon = createGeopointNameIcon({
        name: data.geopunto_name || 'Geopunto',
        textColor: '#000000',
        backgroundColor: data.geopunto_color || 'transparent',
        fontSize: 10,
      });

      const { marker: markerName, error: errorMarkerName } =
        this.leafletMapService.createMarkerWithIconLeaflet(
          coordsResponse,
          icon,
          {
            interactive: false,
          }
        );
      if (errorMarkerName) {
        messageError = errorMarkerName;
        break;
      }

      markerName.setZIndexOffset(200);

      store.push({ markerGeopoint, markerName });
    }

    if (messageError) {
      return { data: null, error: messageError };
    }

    return { data: store, error: null };
  }

  private startLoadingCreateHistory() {
    this.managerLoadingHistoryService.addOrUpdateLoadingHistory(
      KEY_LOADING.CREATE_HISTORY,
      true
    );
  }

  private stopLoadingCreateHistory() {
    this.managerLoadingHistoryService.addOrUpdateLoadingHistory(
      KEY_LOADING.CREATE_HISTORY,
      false
    );
  }

  private sendErrorCreateHistory(error: any) {
    this.managerErrorHistoryService.addOrUpdateErrorHistory(
      KEY_LOADING.CREATE_HISTORY,
      error
    );
  }

  clearErrorCreateHistory() {
    this.managerErrorHistoryService.addOrUpdateErrorHistory(
      KEY_LOADING.CREATE_HISTORY,
      null
    );
  }
}
